module.exports = __webpack_public_path__ + "2015d86837266db8d2215e4f6bad5f0e.jpg";